<template>
  <div class="leaflet-location-search">
    <input
      ref="input"
      v-bind="$attrs"
      :value="query"
      :disabled="loading"
      @input="query = $event.target.value"
      @keyup.enter.prevent="search"
      @change="search"
    >
    <small v-if="loading" class="text-muted">Mencari lokasi...</small>
    <small v-else-if="error" class="text-danger">{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: 'LeafletAutocomplete',
  inheritAttrs: false,
  props: { value: { type: String, default: '' } },
  data() {
    return { query: this.value || '', loading: false, error: '', lastQuery: '' }
  },
  watch: {
    value(value) { this.query = value || '' }
  },
  methods: {
    async search() {
      const query = this.query.trim()
      if (query.length < 3 || query === this.lastQuery || this.loading) return

      this.loading = true
      this.error = ''
      this.lastQuery = query

      try {
        const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&countrycodes=id&q=${encodeURIComponent(query)}`
        const response = await fetch(url, { headers: { Accept: 'application/json' } })
        if (!response.ok) throw new Error('Pencarian lokasi gagal')
        const results = await response.json()
        if (!results.length) throw new Error('Lokasi tidak ditemukan')

        const result = results[0]
        const lat = Number(result.lat)
        const lng = Number(result.lon)
        this.query = result.display_name

        this.$emit('input', this.query)
        this.$emit('place_changed', {
          formatted_address: result.display_name,
          name: result.name || result.display_name,
          geometry: {
            location: {
              lat: () => lat,
              lng: () => lng
            }
          }
        })
      } catch (error) {
        this.error = error.message || 'Lokasi tidak ditemukan'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.leaflet-location-search > input {
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
}
</style>
